import React from "react";
import { useTranslation } from "react-i18next";
import { ApprovalStatus } from "../types";

const CLASS: Record<ApprovalStatus, string> = {
    pending: 'badge-soft-warning',
    approved: 'badge-soft-success',
    rejected: 'badge-soft-danger',
    expired: 'badge-soft-secondary',
    cancelled: 'bg-light text-muted',
};

export const ApprovalStatusBadge = ({ status }: { status: ApprovalStatus }) => {
    const { t } = useTranslation(['workflow']);

    return <span className={'badge ' + (CLASS[status] || '')}>{t('workflow:approvalStatus_' + status)}</span>;
};
